import React from "react";
import "./Top-Section-Mobile.scss";

//import icons
import { GoBell } from "react-icons/go";
import { IoPersonOutline } from "react-icons/io5";
import { ReactComponent as NotificationBellIcon } from "../../../assets/icons/notification-bell.svg";

//data imports
import { useSelector } from "react-redux";

const TopSection = ({ setSharedValue, sharedValue }) => {
  //data from redux
  const user = useSelector((state) => state.landlordslice);

  return (
    <div className="top-section">
      <div>
        <div className="greeting">
          Hello,{" "}
          <span className="name">
            {user?.user?.user?.user_name?.split(" ")[0]}
          </span>
        </div>
        <div className="notification-text">
          <GoBell size={12} />
          <div style={{ marginLeft: "2px" }}>
            no notifications at the moment
          </div>
        </div>
      </div>
      <div className="icons-container">
        <div className="notifications">
          <NotificationBellIcon size={25} />
          {/* <div className="badge">2</div> */}
        </div>
        <button
          style={{ border: "none", backgroundColor: "transparent" }}
          onClick={() => {
            if (setSharedValue) {
              setSharedValue("Profile");
            }
          }}
        >
          <div
            className="notifications"
            style={{
              backgroundColor:
                sharedValue && sharedValue === "Profile" ? "#192A3A" : "",
            }}
          >
            <IoPersonOutline size={25} />
            {/* <div className="badge">2</div> */}
          </div>
        </button>
      </div>
    </div>
  );
};

export default TopSection;
